import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Show,
  SimpleShowLayout,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  DateField,
  required,
  BooleanField,
  ReferenceField,
  BooleanInput,
  DateInput,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  FilterButton,
  CreateButton,
  TopToolbar,
  SearchInput,
} from "react-admin";
import ExportAllButton from "../components/ExportAllButton";
import DynamicDropdownFilter from "../components/DynamicDropdownFilter";

const imageBuildFilters = [
  <SearchInput source="q_name_imageRepository_codeRepository_tag" alwaysOn />,
  <DynamicDropdownFilter
    label="Name"
    source="name"
    resource="cve/image-builds"
  />,
  <DynamicDropdownFilter
    label="Image Repository"
    source="imageRepository"
    resource="cve/image-builds"
  />,
  <DynamicDropdownFilter
    label="Code Repository"
    source="codeRepository"
    resource="cve/image-builds"
  />,
  <DynamicDropdownFilter
    label="Tag"
    source="tag"
    resource="cve/image-builds"
  />,
  <DynamicDropdownFilter
    label="Sha256"
    source="sha256"
    resource="cve/image-builds"
  />,
  <BooleanInput source="signed" />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportAllButton />
  </TopToolbar>
);

export const ImageBuildList = () => (
  <List filters={imageBuildFilters} perPage={25} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="codeRepository" />
      <TextField source="sha256" />
      <BooleanField source="signed" />
      <DateField source="lastScannedAt" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const ImageBuildShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField reference="cve/image-sources" source="imageSource">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" />
      <TextField source="imageRepository" />
      <TextField source="tag" />
      <TextField source="codeRepository" />
      <TextField source="sha256" />
      <BooleanField source="signed" />
      <DateField source="lastScannedAt" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

export const ImageBuildEdit = () => {
  return (
    <Edit redirect="show">
      <SimpleForm>
        <ReferenceInput source="imageSource" reference="cve/image-sources">
          <SelectInput optionText="name" disabled />
        </ReferenceInput>
        <TextInput source="name" disabled />
        <TextInput source="imageRepository" disabled />
        <TextInput source="tag" disabled />
        <TextInput source="codeRepository" disabled />
        <TextInput source="sha256" validate={[required()]} />
        <BooleanInput source="signed" validate={[required()]} />
        <DateInput source="lastScannedAt" />
      </SimpleForm>
    </Edit>
  );
};

export const ImageBuildCreate = () => {
  return (
    <Create redirect={"show"}>
      <SimpleForm>
        <ReferenceInput source="imageSource" reference="cve/image-sources">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput source="tag" validate={[required()]} />
        <TextInput source="sha256" validate={[required()]} />
        <BooleanInput source="signed" validate={[required()]} />
        <DateInput source="lastScannedAt" />
      </SimpleForm>
    </Create>
  );
};
